// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"OtherC_TheComp__3iOfe","TheComp2":"OtherC_TheComp2__WEEbb"};